import { Input } from 'antd';
import styles from './index.module.css';
import type { SearchProps } from 'antd/es/input'; // Используем тип из antd/es/input

export const CustomInputSearch = (
  props: SearchProps & { type: 'large' | 'small' }
) => {
  return (
    <Input.Search
      {...props}
      className={
        props.className
          ? `${props.className} ${styles.customInput} ${
              props.type === 'large'
                ? styles.fontTypeLarge
                : styles.fontTypeSmall
            }`
          : styles.customInput
      }
    />
  );
};
